import moment from 'moment';

export default {
  methods: {
    formatDateLong(dateToFormat) {
      if (dateToFormat != null && dateToFormat.length > 0) {
        if (this.$i18n.locale == 'en') {
          moment.locale('en-ca');
          return moment(dateToFormat).format('dddd, MMMM Do YYYY');
        } else {
          moment.locale('fr-ca');
          return moment(dateToFormat).format('dddd, DD MMMM YYYY');
        }
      } else {
        return '';
      }
    },
    formatDate(dateToFormat) {
      if (dateToFormat == null || dateToFormat.length == 0) {
        return '';
      }

      if (this.$i18n.locale == 'en') {
        moment.locale('en-ca');
        return moment(dateToFormat).format('MMMM Do YYYY');
      } else {
        moment.locale('fr-ca');
        return moment(dateToFormat).format('DD MMMM YYYY');
      }
    },
    formatDateTime(dateToFormat) {
      if (dateToFormat != null && dateToFormat.length > 0) {
        if (this.$i18n.locale == 'en') {
          moment.locale('en-ca');
          return moment(dateToFormat).format('MMMM Do YYYY HH:mm:ss');
        } else {
          moment.locale('fr-ca');
          return moment(dateToFormat).format('DD MMMM YYYY HH:mm:ss');
        }
      } else {
        return '';
      }
    },
    formatDateShort(dateToFormat) {
      if (dateToFormat != null && dateToFormat.length > 0) {
        if (this.$i18n.locale == 'en') {
          moment.locale('en-ca');
          return moment(dateToFormat).format('YY/MM/DD');
        } else {
          moment.locale('fr-ca');
          return moment(dateToFormat).format('YY/MM/DD');
        }
      } else {
        return '';
      }
    },
  },
};
